import { css } from 'emotion'

export const container = css`
  margin-top: 1.5em;
`

export const systemLink = css`
  margin: 0 .5em;
`

export const systemImage = css`
  height: 35px;
  width: auto;
`
